import { useTheme } from '@emotion/react';
import React from 'react';

import { colors } from '../theme/colors';

interface RadioInputMockProps {
  checked: boolean;
  showDarkerBorder?: boolean;
  title: string;
}

export const RadioInputMock: React.FC<RadioInputMockProps> = ({
  checked,
  showDarkerBorder,
  title,
}) => {
  const theme = useTheme();
  const inactiveBorderColor = showDarkerBorder ? colors.neutral75 : colors.neutral80;
  const borderColor = checked ? theme.accent48 : inactiveBorderColor;
  const borderWidth = checked ? '3' : '1';
  const radius = checked ? '8.5' : '9.5';

  const icon = (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>{title}</title>
      <circle cx="10" cy="10" r={radius} stroke={borderColor} strokeWidth={borderWidth} />
      {checked && <circle cx="10" cy="10" r="4.5" fill={borderColor} />}
    </svg>
  );

  return (
    <div role="radio" aria-checked={checked} css={styles.wrapper}>
      {icon}
    </div>
  );
};

const styles = {
  wrapper: {
    cursor: 'inherit',
    height: '20px',
  },
};
